import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function SendIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        xmlns="http://www.w3.org/2000/svg"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 4C12.2841 4 12.5438 4.1605 12.6708 4.41459L19.9208 18.9146C20.0643 19.2016 20.0093 19.5481 19.784 19.7766C19.5587 20.0051 19.2129 20.0649 18.9239 19.9254L12 16.5828L5.07607 19.9254C4.78707 20.0649 4.44134 20.0051 4.216 19.7766C3.99067 19.5481 3.93567 19.2016 4.07918 18.9146L11.3292 4.41459C11.4562 4.1605 11.7159 4 12 4ZM12.75 15.2792L17.5958 17.6186L12 6.42705L6.40424 17.6186L11.25 15.2792V12.75C11.25 12.3358 11.5858 12 12 12C12.4142 12 12.75 12.3358 12.75 12.75V15.2792Z"
        fill="currentColor"
      />
    </svg>
  );
};
